import PriceSlider from "./PriceSlider";
export default PriceSlider;
